import { useContext } from "react";
import { loadingContext } from "../../../Context";
import "./Loader.css";


export default function Loader() {
  const loadingCtx = useContext(loadingContext);
  const isLoading = loadingCtx.state.isLoading;

  return (
    <div className={isLoading ? "loader loading" : "loader"} />
  );
}